module.exports = __webpack_public_path__ + "img/143.0b86d0de.jpg";